export default "__VITE_ASSET__B6dGYuZY__"